/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/9/2023
 */

export const ValuesEnum = Object.freeze({
	NO_LIMIT: -1,
	SIZE_1GB: 1024 * 1024 * 1024,
})
